import * as React from 'react';
import clsx from 'clsx';
import {
    Panel,
    PanelHeader,
    PanelBody,
    AutoScrollbars,
    CloseButton,
    Preloader
} from 'components';
import { IState } from 'services/root-reducer';

import './style.scss';
import {
    getOperation,
    getLayerIcon,
    getLayerObject,
    getOmjsLayerConfig
} from 'selectors';
import { connect } from 'react-redux';
import { ObjectsHelper } from 'utils';
import {
    actions as comparisonActions
} from 'services/objects-comparison/objects-comparison-service';
import {
    actions as mapActions
} from 'services/map/map-service';
import { EOperationStatus } from 'types';
import { isObjectFilesArray } from 'types/omjs/type-checkers';
import { routes, IMapRouteParams } from 'routes';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { WithTranslation, withTranslation } from 'react-i18next';

export interface ICompareWindowProps extends RouteComponentProps<Omit<IMapRouteParams, 'container'>>, WithTranslation {
    compareOperation: IState['operations']['OBJECTS_COMPARISON'];
}
export interface ICompareWindowState {}

const mapStateToProps = (state: IState): Partial<ICompareWindowProps> => ({
    compareOperation: getOperation(state, 'OBJECTS_COMPARISON')
});

class CompareWindowComponent extends React.Component<ICompareWindowProps, ICompareWindowState> {
    thead_el: HTMLDivElement = null;

    constructor(props: ICompareWindowProps) {
        super(props);

        this.renderTableRow = this.renderTableRow.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    componentDidMount() {
        let { object_ids } = this.props.compareOperation.data;
        let has_objects = !!object_ids.length;

        if (!has_objects) {
            this.onCloseClick();
        } else {
            comparisonActions.loadDataForFullWindow();
        }
    }

    componentDidUpdate() {
        let { object_ids } = this.props.compareOperation.data;

        if (object_ids.length === 0) {
            routes.redirect(routes.map, { container: 'root' });
        }
    }

    onCloseClick() {
        let { center, zoom, layers } = this.props.match.params;
        comparisonActions.clearLoadedData();

        routes.redirect(routes.map, {
            center,
            zoom,
            layers,
            container: 'root'
        });
    }

    renderTHEAD() {
        let { object_ids } = this.props.compareOperation.data;

        let additional_headers = object_ids.map((item) => {
            let object = getLayerObject(false, item.layer_code, item.object_id);
            let layer_config = getOmjsLayerConfig(false, item.layer_code);

            return (
                <div
                    key={`${item.layer_code}_${item.object_id}`}
                    className='compare-window-object-title'
                    onClick={() => {
                        mapActions.fitToTarget({
                            layer: item.layer_code,
                            objectId: item.object_id
                        });
                    }}
                >
                    <div className='object-title'>
                        <div className="layer-icon">
                            <img
                                src={getLayerIcon(false, {
                                    layer_code: item.layer_code,
                                    object_id: item.object_id
                                })}
                                alt=""
                            />
                        </div>

                        <div
                            className="object-name"
                            dangerouslySetInnerHTML={{
                                __html: ObjectsHelper.getObjectName(object, layer_config as omjs.ILayerConfig)
                            }}
                        />
                    </div>
                </div>
            );
        });


        return (
            <PanelHeader className='compare-window-header' ref={(el) => { this.thead_el = el; }}>
                <div className='compare-window-title'>{this.props.t('Сравнение площадок')}</div>
                {...additional_headers}
                <CloseButton onClick={this.onCloseClick} />
            </PanelHeader>
        );
    }

    renderTBODY() {
        let { status } = this.props.compareOperation;

        if (status !== EOperationStatus.SUCCESS) {
            return (
                <PanelBody className='compare-window-body preloader-body'>
                    <Preloader />
                </PanelBody>
            );
        } else {
            let { layer_structure } = this.props.compareOperation.data;

            return (
                <PanelBody className={clsx('compare-window-body')}>
                    <div className="autoscroll-fix-wrapper">
                        <AutoScrollbars>
                            <div className="content-wrapper">
                                {layer_structure.map(this.renderTableRow)}
                            </div>
                        </AutoScrollbars>
                    </div>
                </PanelBody>
            );
        }
    }

    renderTableRow(
        column: ObjectsHelper.IModifiedStructureColumn,
        index: number,
        structure: ObjectsHelper.IModifiedStructureColumn[]
    ) {
        if (!column.name) return null;

        let { objects, object_ids } = this.props.compareOperation.data;
        let is_title = column.type === 'title';
        let next_item = structure[index + 1];
        let is_last = next_item?.level === 0 ?? false;

        return (
            <div
                className={clsx(
                    'row',
                    `level-${column.level}`,
                    {
                        'is-title': is_title,
                        'is-last': is_title && is_last,
                        'followed-by-title': (next_item?.type === 'title' ?? false)
                    }
                )}
                key={column.code}
            >
                <div className='row-header'>
                    {column.name}
                </div>
                {!is_title && object_ids.map((i) => {
                    let object = objects.find(obj => obj.id === i.object_id);
                    let value = (object.fields[`#${column.code}`] || object.fields[column.code]) || '';
                    if (isObjectFilesArray(value)) {
                        return (
                            <div
                                key={`${object.id}_${column.code}`}
                                className='row-object-value'
                            >
                                {this.props.t('FILES_COUNT_0', { count: value.length }) }
                            </div>
                        );
                    } else {
                        let formatted_value = value.toString().split('\n').join('<br />');
                        return (
                            <div
                                key={`${object.id}_${column.code}`}
                                className='row-object-value'
                                dangerouslySetInnerHTML={{
                                    __html: formatted_value.length ? formatted_value : '-'
                                }}
                            />
                        );
                    }
                })}
            </div>
        );
    }

    render() {
        let { object_ids } = this.props.compareOperation.data;
        let has_objects = !!object_ids.length;

        if (!has_objects) {
            return null;
        }

        return (
            <Panel className={clsx('compare-window', `rows-${object_ids.length + 1}`)}>
                {this.renderTHEAD()}
                {this.renderTBODY()}
            </Panel>
        );
    }
}

export const CompareWindow = withRouter(
    // @ts-ignore
    connect(mapStateToProps)(
        withTranslation()(CompareWindowComponent)
    )
);
